<div class="container " id="page-content-main">
  <div class="mt-4">
    <div class="">
      <mat-card class="mb-3" style="border-radius: 10px">
        <mat-card-content>
          <a [routerLink]="['/home']" class="ts-l tw-b">
              <span class="fa fa-chevron-circle-left fa-sm-blue" matTooltip="GO BACK"
              matTooltipClass="tooltip-md">
            </span>
            Back
          </a>
          <br><br>
          <div class="container-fluid">
            <h2>Noncustodial Parent FAQ</h2>
            <p>
              Welcome to the SMART Child Support Internet Payment Web Site.
            </p>
            <div class="accordion accordion-flush" id="accordionFlushExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingSix">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix"
                    style="font-weight: bold;">
                    Credit Card FAQs
                  </button>
                </h2>
                <div id="flush-collapseSix" class="accordion-collapse collapse" aria-labelledby="flush-headingSix"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Does the SMART Child Support Internet Payment Website collect or store my credit card information?
                        </mat-expansion-panel-header>
                          <div class="mx-2 pt-3 pt-sm-0">
                            No, your credit card information is not collected or stored by the SMART Child Support Internet Payment Website. 
                            For security purposes, your credit card information is collected and stored by our credit card processor.
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          What credit cards do you accept?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            You may use American Express®, Mastercard®, Visa®, Discover®, JCB®, or Maestro® to make a child support payment.                                    
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          What information is required to make a credit card payment?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            The following information is required to make a credit card payment: <br>
                            &bull; Non-custodial parent's first and last name <br>
                            &bull; Non-custodial parent's social security number <br>
                            &bull; Non-custodial parent's date of birth <br>
                            &bull; Credit card holder's name <br>
                            &bull; Credit card holder's billing address <br>
                            &bull; Valid e-mail address <br>
                            &bull; American Express®, Mastercard®, Visa®, Discover®, JCB®, or Maestro® credit card number and expiration date and CVV2/ CVC2 3 or 4-digit security code. <br>
                       
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          What is the CVV2/ CVC2 security code and where do I find it?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            &bull; The CVV2/ CVC2 3 or 4-digit security code is an added security measure. It is used to establish that you are 
                            in possession of the credit card. <br>
                            &bull; Discover, Mastercard, Visa, and JCB print a 3-digit code on the back of the 
                            card. <br>
                            &bull; Maestro uses the last 3 digits of the card number as the security code. American Express prints a 4-digit 
                            code on the front of the card. <br>                      
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          What should I do if I don't have an e-mail address?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            A valid e-mail address is required for us to communicate with you electronically. If you do not have 
                            an e-mail address, we cannot send you information such as a confirmation of your transactions. Free 
                            e-mail accounts are available on the Internet. To locate one, use any search engine and search for "free e-mail."                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Can I charge child support payments to my credit card, if I am under an Income Withholding Order?
                        </mat-expansion-panel-header>
                          <div class="mx-2 pt-3 pt-sm-0">
                            Yes, but income withholding will remain in effect and not be terminated.
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Can I make a credit card payment by phone?
                        </mat-expansion-panel-header>
                        <div class="mx-2">
                          Yes, you can make a <strong>non-recurring</strong> payment by calling 1-877-260-5480.
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Is there a minimum payment requirement?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            Yes, there is a minimum payment requirement of $1.00.                 
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          What is the maximum payment that I can make? 
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            The maximum payment that you can make in one transaction is $9,999.99; assuming your card has that amount 
                            of credit available. Multiple transactions can be made in one day if each transaction does not exceed 
                            $9,999.99, and the appropriate amount of credit is available.              
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Can I split one payment across multiple credit cards?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            No, you cannot split your payment across multiple credit cards.                         
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          When will my credit/ debit card be charged for my child support payment?
                        </mat-expansion-panel-header>
                        <div class="mx-2">
                          Your card is charged at the time you submit the transaction, and your credit/ debit card company authorizes it.
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          When will my payment be posted to my child support account?
                        </mat-expansion-panel-header>
                        <div class="mx-2">
                          Your payment will be applied within two to three business days from the day it was made on the web site.                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Can I make a payment for a non-custodial parent with my credit card?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            Yes, you can use your credit card to make a payment for a non-custodial parent; however, you will need their first and last name, social security number, and date of birth.        
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          My credit card transaction was declined, what should I do?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            You will need to contact your credit card company to determine why the payment was not authorized. The following are some of the reasons the transaction could have been declined: <br>
                            <span style="display: block; text-indent: -1em; padding-left: 1em;">&bull; The credit card number and/ or CVV2/ CVC2 security code was incorrectly entered.</span>
                            <span style="display: block; text-indent: -1em; padding-left: 1em;">&bull; There is a discrepancy between the address you entered and the billing address that is on file with the card-issuing bank. You must enter the billing address that appears on your credit card statement.</span>
                            <span style="display: block; text-indent: -1em; padding-left: 1em;">&bull; A foreign address (a country other than the US) was entered. The web site is unable to process credit card payments with a foreign address.</span>
                            <span style="display: block; text-indent: -1em; padding-left: 1em;">&bull; There is insufficient credit available for the payment amount.</span>
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          How do I obtain a refund on a credit card payment made through this website?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            You will need to contact SMI Pay Tribal Child Support Services at 1-877-279-4730.                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingNine">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseNine" aria-expanded="false" aria-controls="flush-collapseNine"
                  style="font-weight: bold;">
                  Questions About Technical Issues
                </button>
                </h2>
                <div id="flush-collapseNine" class="accordion-collapse collapse" aria-labelledby="flush-headingNine"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          It appears there is a problem with the web site. What do I need to do?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            Contact Customer Service at 1-877-279-4730 to report the problem. 
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingTen">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTen" aria-expanded="false" aria-controls="flush-collapseTen"
                    style="font-weight: bold;">
                    Contact Information
                  </button>
                </h2>
                <div id="flush-collapseTen" class="accordion-collapse collapse" aria-labelledby="flush-headingTen"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body mx-3">
                    <h3>Customer Service Telephone Number</h3>
                    1-877-279-4730, Monday-Friday, 8:00 a.m. to 5:00 p.m., Central Time (CT), excluding state and federal holidays. <br>
                    <br>
                    <p style="font-weight: bold; font-size: 0.95rem;">Note: All questions related to a child support case should be 
                      directed to your tribal child support office.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
